// pages/SAPProcessMapIssues.jsx — "Past issues & solutions" for the selected Process Map step.
// Lists Solman tickets classified to this step (GET /api/sap-procmap/issues?step=…): only real
// process issues and change requests of a matching module, best match first, with the core
// team's replies. Master-data requests (new item code, BOM upload, price templates…) are not
// listed here; the panel says how many exist and links to them in the "Solman tickets" section.
import { useEffect, useState } from 'react';
import { api } from '../context/AuthContext';
import { TicketRow, TICKET_OBJ_LABEL } from './SAPProcessMapTickets';

export default function SAPProcessMapIssues({ landKey, flowKey, step, coCode, color, lang, onOpenTickets }) {
  const id = lang === 'id';
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  const [q, setQ] = useState('');
  const [open, setOpen] = useState(null);

  useEffect(() => {
    let live = true;
    setD(null); setErr(null); setOpen(null);
    api.get('/api/sap-procmap/issues', { params: { land: landKey, step: step.id, flow: flowKey, limit: 60 } })
      .then(r => { if (live) setD(r.data); })
      .catch(e => { if (live) setErr(e?.response?.data?.error || e.message); });
    return () => { live = false; };
  }, [landKey, flowKey, step.id]);

  const ql = q.trim().toLowerCase();
  const list = (d?.tickets || []).filter(t => !ql || (t.ticket_id + ' ' + t.description + ' ' + t.texts.map(x => x.text).join(' ')).toLowerCase().includes(ql));
  const objLbl = d?.md_obj ? (TICKET_OBJ_LABEL[d.md_obj] || TICKET_OBJ_LABEL[''])[id ? 1 : 0] : '';

  return (
    <div className="bg-white border border-slate-200 rounded-xl px-5 py-4" style={{ borderLeft: `4px solid ${color}` }}>
      <div className="flex flex-wrap items-baseline gap-2">
        <div className="text-[14px] font-bold text-slate-800">{id ? 'Issue & solusi sebelumnya' : 'Past issues & solutions'}</div>
        <div className="text-[12px] text-slate-500">
          {d && !d.note ? (id ? `${d.total} tiket masalah untuk langkah ini` : `${d.total} issue tickets for this step`) : ''}
          {d && d.total > (d.tickets || []).length ? (id ? ` · ${d.tickets.length} paling relevan ditampilkan` : ` · top ${d.tickets.length} shown`) : ''}
        </div>
        <input value={q} onChange={e => setQ(e.target.value)} placeholder={id ? 'Cari di tiket & jawaban…' : 'Search tickets & replies…'}
          className="ml-auto border border-slate-200 rounded-lg px-2.5 py-1 text-[12.5px] w-full sm:w-64" />
      </div>
      {d && !d.note && (
        <div className="text-[11px] text-slate-400 mt-1">
          {id ? 'Diurutkan menurut relevansi · modul ' : 'Sorted by relevance · module '}{(d.modules || []).join('/')}
          {id ? ' · permintaan master data dan user/akses tidak ditampilkan' : ' · master-data and user/access requests are left out'}
          {coCode ? (id ? ` · semua company (filter ${coCode} tidak berlaku)` : ` · all companies (the ${coCode} filter does not apply)`) : ''}
        </div>
      )}
      {d && d.md_count > 0 && onOpenTickets && (
        <button type="button" onClick={() => onOpenTickets({ kind: 'masterdata', obj: d.md_obj })}
          className="mt-1.5 text-[11.5px] font-semibold hover:underline" style={{ color }}>
          {id ? `→ ${d.md_count.toLocaleString('id-ID')} permintaan master data terkait (${objLbl})` : `→ ${d.md_count.toLocaleString()} related master-data requests (${objLbl})`}
        </button>
      )}
      {err && <p className="text-[12.5px] text-red-600 mt-2">{err}</p>}
      {!d && !err && <p className="text-[12.5px] text-slate-400 mt-2">{id ? 'Memuat…' : 'Loading…'}</p>}
      {d && d.note && <p className="text-[12.5px] text-slate-500 mt-2">{d.note}</p>}
      {d && !d.note && !list.length && <p className="text-[12.5px] text-slate-500 mt-2">{id ? 'Tidak ada tiket masalah untuk langkah ini.' : 'No issue tickets for this step.'}</p>}
      <div className="mt-2 divide-y divide-slate-100">
        {list.map(t => <TicketRow key={t.ticket_id} t={t} id={id} color={color} open={open === t.ticket_id} onToggle={() => setOpen(open === t.ticket_id ? null : t.ticket_id)} />)}
      </div>
    </div>
  );
}
